import React, { Context } from "react";
import {
    PageItem,
    PageData,
    PageProps,
} from "../components/component-switcher";
import { AppContextInterface, AppContext } from "../app-context-provider";
import ArchiveCategory, { ArchiveCategoryProps } from "./archive-category";
import SectionTitle from "../components/section-title";
import { generateSectionId, createCategories } from "../helpers/layout-helpers";

export interface CategorisedArchiveData extends PageData {
    children: CategorisedItem[];
}

export interface CategorisedArchiveProps extends PageProps {
    page: CategorisedPage;
    columns: number;
    component: React.ComponentType;
    hideTitle: boolean;
    fitContent: boolean;
    itemChildren: CategorisedItem[];
}

export interface CategorisedPage extends PageProps {
    data: CategorisedArchiveData;
}

export interface CategorisedItem extends PageItem {
    tags: string[];
}

export interface CategorisedPageState {
    columns: number;
}

class CategorisedArchive extends React.Component<CategorisedArchiveProps> {
    pageBodyRef: React.RefObject<any> = React.createRef();
    static contextType: Context<AppContextInterface | null> = AppContext;
    public context!: AppContextInterface;
    public state: CategorisedPageState = { columns: 3 };

    renderCategories() {
        let categories: ArchiveCategoryProps[] = createCategories(
            this.props.itemChildren,
            this.props.component
        );
        if (categories.length === 0) {
            let newTag: ArchiveCategoryProps = { ...this.props };
            return [<ArchiveCategory {...newTag} />];
        }
        return categories.map(
            (tag) => <ArchiveCategory {...tag} columns={this.props.columns} />
            //let tagHeading = <h1 key={tag.name + '-h1'}>Photo Style:</h1>
            //let tagSubHeading = <h2 key={tag.name + '-h2'}style={{ color: this.context.colors.textColors.secondaryColor }}>{tag.name}</h2>
            //elements.push(tagHeading);
            //elements.push(tagSubHeading);
            //elements.push(<PageGrid key={tag.name + '-grid'} columns={2}>{tag.items.map((item: PhotoItem) => <PhotoComponent key={item.key} item={item} />) }</PageGrid> );
        );
    }

    render() {
        let className = `${this.props.type.toLowerCase()}`;
        if (this.props.sideMenuTitle) {
            className += " can-scroll-to";
        }
        return (
            <section className={className} id={generateSectionId(this.props)}>
                <SectionTitle title={this.props.mainTitle} />
                {this.renderCategories()}
            </section>
        );
    }
}

export default CategorisedArchive;
